
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

try {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  console.error("React Mounting Error:", error);
  rootElement.innerHTML = `<div style="color: white; padding: 20px; font-family: sans-serif;">
    <h2>Anwendungsfehler</h2>
    <p>Die App konnte nicht geladen werden. Bitte prüfen Sie die Browser-Konsole für Details.</p>
    <pre style="background: rgba(255,0,0,0.1); padding: 10px; border-radius: 5px;">${error}</pre>
  </div>`;
}
